var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 7.31901C7.33398 7.1422 7.40422 6.97263 7.52925 6.84761C7.65427 6.72258 7.82384 6.65234 8.00065 6.65234C8.17746 6.65234 8.34703 6.72258 8.47206 6.84761C8.59708 6.97263 8.66732 7.1422 8.66732 7.31901V11.319C8.66732 11.4958 8.59708 11.6654 8.47206 11.7904C8.34703 11.9154 8.17746 11.9857 8.00065 11.9857C7.82384 11.9857 7.65427 11.9154 7.52925 11.7904C7.40422 11.6654 7.33398 11.4958 7.33398 11.319V7.31901Z",
    fill: "#4F3EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 4.03125C7.82384 4.03125 7.65427 4.10149 7.52925 4.22651C7.40422 4.35154 7.33398 4.52111 7.33398 4.69792C7.33398 4.87473 7.40422 5.0443 7.52925 5.16932C7.65427 5.29435 7.82384 5.36458 8.00065 5.36458C8.17746 5.36458 8.34703 5.29435 8.47206 5.16932C8.59708 5.0443 8.66732 4.87473 8.66732 4.69792C8.66732 4.52111 8.59708 4.35154 8.47206 4.22651C8.34703 4.10149 8.17746 4.03125 8.00065 4.03125Z",
    fill: "#4F3EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 1.33203C4.31865 1.33203 1.33398 4.3167 1.33398 7.9987C1.33398 11.6807 4.31865 14.6654 8.00065 14.6654C11.6827 14.6654 14.6673 11.6807 14.6673 7.9987C14.6673 4.3167 11.6827 1.33203 8.00065 1.33203ZM2.66732 7.9987C2.66732 9.41319 3.22922 10.7697 4.22941 11.7699C5.22961 12.7701 6.58616 13.332 8.00065 13.332C9.41514 13.332 10.7717 12.7701 11.7719 11.7699C12.7721 10.7697 13.334 9.41319 13.334 7.9987C13.334 6.58421 12.7721 5.22766 11.7719 4.22746C10.7717 3.22727 9.41514 2.66536 8.00065 2.66536C6.58616 2.66536 5.22961 3.22727 4.22941 4.22746C3.22922 5.22766 2.66732 6.58421 2.66732 7.9987Z",
    fill: "#4F3EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6dc3c3affae3f645a7431ee6b5fba16b.svg";
export { ForwardRef as ReactComponent };